"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var context_exports = {};
__export(context_exports, {
  MeasureMetricsContext: () => MeasureMetricsContext,
  NoMetricsContext: () => NoMetricsContext,
  addOperation: () => addOperation,
  consoleLogger: () => import_context_utils2.consoleLogger,
  noParamsLogger: () => import_context_utils2.noParamsLogger,
  nullPromise: () => import_context_utils2.nullPromise,
  registerOperationLog: () => registerOperationLog,
  setOperationLogProfiling: () => setOperationLogProfiling,
  updateOperationLog: () => updateOperationLog,
  withContext: () => withContext
});
module.exports = __toCommonJS(context_exports);
var import_base_measure_context = require("./base-measure-context");
var import_context_utils = require("./context-utils");
var import_metrics = require("./metrics");
var import_context_utils2 = require("./context-utils");
class MeasureMetricsContext extends import_base_measure_context.BaseMeasureContext {
  static {
    __name(this, "MeasureMetricsContext");
  }
  constructor(name, params, fullParams = import_metrics.EMPTY_PARAMS, metrics = (0, import_metrics.newMetrics)(), logger, parent, logParams, logLevel = "info") {
    super(name, params, fullParams, metrics, logger, parent, logParams, logLevel);
  }
  gauge(name, value) {
    this.recordValue(name, value, true);
  }
  counter(name, value) {
    this.recordValue(name, value);
  }
  recordValue(name, value, override) {
    const metrics = (0, import_metrics.childMetrics)(this.metrics, "#" + name);
    metrics.namedParams = metrics.namedParams ?? {};
    (0, import_metrics.updateMeasure)(metrics, (0, import_context_utils.platformNow)(), import_metrics.EMPTY_PARAMS, import_metrics.EMPTY_PARAMS, void 0, value, override);
  }
  createChild(name, params, fullParams, opt) {
    return new MeasureMetricsContext(
      name,
      params,
      fullParams,
      (0, import_metrics.childMetrics)(this.metrics, name),
      opt?.logger ?? this.logger,
      this,
      this.logParams,
      opt?.logLevel ?? this.logLevel
    );
  }
  extractMeta() {
    return {};
  }
}
class NoMetricsContext {
  static {
    __name(this, "NoMetricsContext");
  }
  logger;
  id;
  contextData = {};
  logLevel;
  constructor(logger, logLevel = "info") {
    this.logger = logger ?? (0, import_context_utils.consoleLogger)({});
    this.logLevel = logLevel;
  }
  gauge(name, value) {
  }
  counter(name, value) {
  }
  newChild(name, params, opt) {
    const result = new NoMetricsContext(opt?.logger ?? this.logger, opt?.logLevel ?? this.logLevel);
    result.id = this.id;
    result.contextData = this.contextData;
    return result;
  }
  with(name, params, op, fullParams) {
    const r = op(this.newChild(name, params, { fullParams, logger: this.logger }));
    return Promise.resolve(r);
  }
  extractMeta() {
    return {};
  }
  withSync(name, params, op, fullParams) {
    const c = this.newChild(name, params, { fullParams, logger: this.logger });
    return op(c);
  }
  withLog(name, params, op, fullParams) {
    const r = op(this.newChild(name, params, { fullParams, logger: this.logger }));
    return Promise.resolve(r);
  }
  error(message, args) {
    this.logger.error(message, { ...args });
  }
  info(message, args) {
    this.logger.info(message, { ...args });
  }
  warn(message, args) {
    this.logger.warn(message, { ...args });
  }
  debug(message, args) {
    if (this.logLevel !== "debug") return;
    this.logger.debug(message, { ...args });
  }
  end() {
  }
  getParams() {
    return {};
  }
}
function withContext(name, params = {}, options) {
  return (target, propertyKey, descriptor) => {
    const originalMethod = descriptor.value;
    descriptor.value = function(...args) {
      const ctx = args[0];
      return ctx.with(
        name,
        params,
        (ctx2) => originalMethod.apply(this, [ctx2, ...args.slice(1)]),
        {},
        options
      );
    };
    return descriptor;
  };
}
__name(withContext, "withContext");
let operationProfiling = false;
function setOperationLogProfiling(value) {
  operationProfiling = value;
}
__name(setOperationLogProfiling, "setOperationLogProfiling");
let globalId = 0;
function registerOperationLog(ctx) {
  if (!operationProfiling) {
    return {};
  }
  const op = { start: (0, import_context_utils.platformNow)(), ops: [], end: -1 };
  let opLogMetrics;
  if (ctx.id === void 0) {
    ctx.id = "op_" + (++globalId).toString(16);
  }
  if (ctx.metrics !== void 0) {
    if (ctx.metrics.opLog === void 0) {
      ctx.metrics.opLog = {};
    }
    ctx.metrics.opLog[ctx.id] = op;
    opLogMetrics = ctx.metrics;
  }
  return { opLogMetrics, op };
}
__name(registerOperationLog, "registerOperationLog");
function updateOperationLog(opLogMetrics, op) {
  if (!operationProfiling) {
    return;
  }
  if (op !== void 0) {
    op.end = (0, import_context_utils.platformNow)();
  }
  if (opLogMetrics?.opLog !== void 0) {
    const entries = Object.entries(opLogMetrics.opLog);
    const incomplete = entries.filter((it) => it[1].end === -1);
    const complete = entries.filter((it) => it[1].end !== -1);
    complete.sort((a, b) => a[1].start - b[1].start);
    if (complete.length > 30) {
      complete.splice(0, complete.length - 30);
    }
    opLogMetrics.opLog = Object.fromEntries(incomplete.concat(complete));
  }
}
__name(updateOperationLog, "updateOperationLog");
function addOperation(ctx, name, params, op, fullParams) {
  if (!operationProfiling) {
    return op(ctx);
  }
  let opEntry;
  let p = ctx;
  let opLogMetrics;
  let id;
  while (p !== void 0) {
    if (p.metrics?.opLog !== void 0) {
      opLogMetrics = p.metrics;
    }
    if (id === void 0 && p.id !== void 0) {
      id = p.id;
    }
    p = p.parent;
  }
  const opLog = id !== void 0 ? opLogMetrics?.opLog?.[id] : void 0;
  if (opLog !== void 0) {
    opEntry = {
      op: name,
      start: (0, import_context_utils.platformNow)(),
      params: {},
      end: -1
    };
  }
  const result = op(ctx);
  if (opEntry !== void 0 && opLog !== void 0) {
    const record = /* @__PURE__ */ __name(() => {
      opEntry.end = (0, import_context_utils.platformNow)();
      opEntry.params = { ...params, ...typeof fullParams === "function" ? fullParams() : fullParams };
      opLog.ops.push(opEntry);
    }, "record");
    void result.then(record, record);
  }
  return result;
}
__name(addOperation, "addOperation");
//# sourceMappingURL=context.js.map
